import fetch from '@/utils/fetch'
import {wymsFetch} from '@/utils/fetch'

/**
 * 统一处理请求参数
 * */
function filterURLSearchParams(args = {}) {
  const params = new URLSearchParams();
  Object.keys(args).forEach(key => {
    params.append(key, args[key])
  });
  return params
}

/**
 * 判断是否经销商管理员或经销商客服身份
 * */
export function isBusinessManager(args) {
  return wymsFetch({
    url: 'schoolActive/isBussinessManager',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 获取学段列表
 * */
export function getSchoolStages(args) {
  return wymsFetch({
    url: 'schoolActive/getSchoolStages',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 学校活跃度统计和下载
 * */
export function listSchoolActive(args) {
  return wymsFetch({
    url: 'schoolActive/listSchoolActive',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 省市区
 * */
export function listAreaByParentCode(args) {
  return wymsFetch({
    url: 'school/listAreaByParentCode',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 获取客服人员列表（包含客服组长）
 * */
export function listRoleCustomer(args) {
  return wymsFetch({
    url: 'schoolReport/listRoleCustomer',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 查询学校关注报表
 * */
export function listSchoolUserReports(args) {
  return wymsFetch({
    url: 'schoolReport/listSchoolUserReports',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

export function getDiseaseTripSchoolListByPage(args) {
    return fetch({
        url: 'structure/diseaseTrip/getDiseaseTripSchoolListByPage',
        method: 'GET',
        params: filterURLSearchParams(args)
    })
}



// WEBPACK FOOTER //
// ./src/api/dataAnalysis.js